import React from 'react';
import { Star } from 'lucide-react';
interface TestimonialCardProps {
  name: string;
  age: number;
  city: string;
  content: string;
  rating?: number;
  imageSrc: string;
  timeframe: string;
  verified?: boolean;
}
export function TestimonialCard({
  name,
  age,
  city,
  content,
  rating = 5,
  imageSrc,
  timeframe,
  verified = true
}: TestimonialCardProps) {
  return <div className="bg-white p-6 rounded-xl shadow-md border border-gray-100 flex flex-col h-full" data-id="element-338">
      <div className="flex items-center gap-4 mb-4" data-id="element-339">
        <div className="w-12 h-12 rounded-full overflow-hidden bg-gray-200 flex-shrink-0" data-id="element-340">
          <img src={imageSrc} alt={name} className="w-full h-full object-cover" data-id="element-341" />
        </div>
        <div data-id="element-342">
          <h4 className="font-bold text-gray-900" data-id="element-343">{name}</h4>
          <p className="text-xs text-gray-500" data-id="element-344">
            {age} años • {city}
          </p>
        </div>
      </div>

      <div className="flex gap-1 mb-3" data-id="element-345">
        {[...Array(rating)].map((_, i) => <Star key={i} className="w-4 h-4 fill-[#D4AF37] text-[#D4AF37]" data-id="element-346" />)}
      </div>

      <p className="text-gray-700 text-sm leading-relaxed mb-4 flex-grow italic" data-id="element-347">
        "{content}"
      </p>

      <div className="flex items-center justify-between pt-4 border-t border-gray-100 mt-auto" data-id="element-348">
        <span className="text-xs font-semibold text-[#2D5016] bg-green-50 px-2 py-1 rounded" data-id="element-349">
          {timeframe}
        </span>
        {verified && <span className="text-xs text-gray-400 flex items-center gap-1" data-id="element-350">
            <span className="w-2 h-2 bg-green-500 rounded-full" data-id="element-351"></span>
            Compra Verificada
          </span>}
      </div>
    </div>;
}